import Utils from '@/ecm/common/Utils'
export default class GroupItem {
    constructor(dto) {
        this.uuid = Utils.object.getUUID()
        this.fieldTitle = ''
        this.sumFields = []
        this.maxFields = []
        this.minFields = []
        this.avgFields = []
        this.summarizeOnlySelectedDocuments = false

        if (dto) {
            this.fieldTitle = dto.FieldTitle;
            this.avgFields = dto.AvgFields;
            this.maxFields = dto.MaxFields;
            this.minFields = dto.MinFields;
            this.sumFields = dto.SumFields;
        }
    }
}
